<template>
  <div>
    <vue-hcaptcha ref="hcaptcha" :sitekey="hcaptchaSiteKey" size="invisible" :re-captcha-compat="false"
                  @verify="setHcaptchaResponseAndSubmit" />
    <validation-errors v-if="showValidationError" :errors="[validationErrorMessage]" class="mb-1" />
    <submit-button :form-valid="formValid" :label="label" :submitting-label="submittingLabel"
                   :submit-in-progress="submitInProgress" :class="buttonClass"
                   @click="executeHcaptcha" />
  </div>
</template>

<script>
import SubmitButton from './submit-button'
import ValidationErrors from '@/components/inputs/validation-errors'
import VueHcaptcha from '@hcaptcha/vue3-hcaptcha'

export default {
  components: { SubmitButton, ValidationErrors, VueHcaptcha },

  props: {
    // This prop needs to be named `buttonClass` rather than `class` because ESLint will
    // throw a vue/no-parsing-error error if a prop is named `class`.
    buttonClass: {
      type: String,
      required: false,
      default: ''
    },
    formValid: {
      type: Boolean,
      required: false,
      default: true
    },
    label: {
      type: String,
      required: true
    },
    submitInProgress: {
      type: Boolean,
      required: false,
      default: false
    },
    submittingLabel: {
      type: String,
      required: false
    },
    validationErrors: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  emits: ['submit-with-token'],

  data() {
    return {
      hcaptchaResponse: null
    }
  },

  computed: {
    hcaptchaSiteKey() {
      return this.agraConfiguration.botProtection.siteKey
    },

    showValidationError() {
      return !!this.validationErrors.hcaptchaVerifyResult
    },

    validationErrorMessage() {
      return this.i18n.t('public.bot_protection.rejected', {org_name: this.agraConfiguration.organisationName})
    }
  },

  methods: {
    executeHcaptcha() {
      this.$refs.hcaptcha.execute()
    },

    setHcaptchaResponseAndSubmit(token) {
      this.hcaptchaResponse = token
      this.$emit('submit-with-token', {hcaptchaResponse: this.hcaptchaResponse})
    }
  }
}
</script>
